<ng-content select="layout-header">
  @if (isDesktop()) {
    <cheelee-header [isFixed]="isHeaderFixed()" />
  }
</ng-content>

<ng-content />

@if (displayNavBar()) {
  <cheelee-nav-bar />
}

@if (isDesktop()) {
  <cheelee-footer [isCompact]="isFooterCompact()" />
}
